import { z } from 'zod';
export const PERMISSIONS = [
    'manageBrands',
    'manageBranches',
    'setGeofenceRadius',
    'bulkImportCatalog',
    'reviewUnlistedBranches',
    'manageForms',
    'manageUsers',
    'viewAnalytics',
    'viewAnomalies',
    /** Plan visits for the agents of one's own team (a super admin: every agent). */
    'assignVisits',
    'manageZoho',
    'manageAppDistribution',
    'mobileCheckin',
    /** See other agents' shift locations (live map, routes). Not granted to any role by default; every view is audited (D90). */
    'viewAgentLocation',
    /** Compose and send push notifications. Not granted to any role by default (D97). */
    'sendNotifications',
];
export const permissionSchema = z.enum(PERMISSIONS);
export const ROLES = ['SUPER_ADMIN', 'OPERATIONS_MANAGER', 'FORM_DESIGNER', 'SUPERVISOR', 'FIELD_AGENT'];
export const roleSchema = z.enum(ROLES);
/**
 * Default permissions per role, taken verbatim from the web "Access Matrix".
 * Seeded into the RolePermission table; the server always reads the DB.
 * SUPER_ADMIN always holds every permission (enforced in code to prevent lock-out).
 * Pending business review - see DECISIONS.md.
 */
export const ROLE_DEFAULT_PERMISSIONS = {
    SUPER_ADMIN: PERMISSIONS,
    OPERATIONS_MANAGER: [
        'manageBrands',
        'manageBranches',
        'setGeofenceRadius',
        'bulkImportCatalog',
        'reviewUnlistedBranches',
        'viewAnalytics',
        'assignVisits',
    ],
    FORM_DESIGNER: ['manageForms'],
    SUPERVISOR: ['reviewUnlistedBranches', 'viewAnalytics', 'viewAnomalies', 'assignVisits', 'mobileCheckin'],
    FIELD_AGENT: ['mobileCheckin'],
};
export const permissionOverrideSchema = z.object({
    permission: permissionSchema,
    granted: z.boolean(),
});
export function resolveEffectivePermissions(role, roleDefaults, overrides) {
    if (role === 'SUPER_ADMIN')
        return [...PERMISSIONS];
    const effective = new Set(roleDefaults);
    for (const override of overrides) {
        if (override.granted)
            effective.add(override.permission);
        else
            effective.delete(override.permission);
    }
    return PERMISSIONS.filter((p) => effective.has(p));
}
export function hasPermission(permissions, ...required) {
    return required.every((p) => permissions.includes(p));
}
export function hasAnyPermission(permissions, ...candidates) {
    return candidates.some((p) => permissions.includes(p));
}
//# sourceMappingURL=permissions.js.map